import { render, staticRenderFns } from "./ProCard.vue?vue&type=template&id=a650163c&scoped=true&"
import script from "./ProCard.vue?vue&type=script&lang=js&"
export * from "./ProCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a650163c",
  null
  
)

export default component.exports